/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TransactionTitle {
    LEGAL_TITLE = 'LEGAL_TITLE',
    BENEFICIAL_INTEREST = 'BENEFICIAL_INTEREST',
    BENEFICIAL_INTEREST_AND_LEGAL_TITLE = 'BENEFICIAL_INTEREST_AND_LEGAL_TITLE',
}
